interface Props {
	children: React.ReactNode;
}
import Styles from './components.module.scss';
export default function BigNumberContainer({ children }: Props) {
	return (
		<div className={`${Styles.big_numbers_container} tour-relatorio-5`}>
			<div className={Styles.bigNumberList}>{children}</div>
		</div>
	);
}
